module.exports = __webpack_public_path__ + "static/media/Avatar_6.9b22243a.svg";